import React from 'react';
import { FormContainer, ParentContainer } from '../../styles';
import { HILL_BLUE_ICON, LOADER_ICON } from '@Images';
import { AADHAR_VERIFICATION } from '../../utils/constants';
import { AadharSuccessContainer, LoaderImage } from './style';
import Transition from 'semantic-ui-react/dist/commonjs/modules/Transition';

interface IAadharSuccess {
  loading: boolean;
}
const AadharSuccess: React.FC<IAadharSuccess> = (props) => {
  const { loading } = props;
  const { aadharVerified, redirectShortly, fetchingAadharDetails, dontCloseWindow } =
    AADHAR_VERIFICATION;

  return (
    <>
      <ParentContainer padding={[30, 24, 0, 24]}>
        <FormContainer margin={200}>
          {loading ? (
            <>
              <Transition visible={true} duration={300}>
                <LoaderImage src={LOADER_ICON} alt="loader" />
              </Transition>
              <AadharSuccessContainer>
                <p className="fetchingDetails">{fetchingAadharDetails}</p>
                <p className="redirectingShortly">{dontCloseWindow}</p>
              </AadharSuccessContainer>
            </>
          ) : (
            <>
              <img src={HILL_BLUE_ICON} alt="logo" />
              <AadharSuccessContainer>
                <p className="aadharVerified">{aadharVerified}</p>
                <p className="redirectingShortly">{redirectShortly}</p>
              </AadharSuccessContainer>
            </>
          )}
        </FormContainer>
      </ParentContainer>
    </>
  );
};

export default AadharSuccess;
